import {connect} from '@modifi/redux'
import {aFetchAnnouncementData, selectAnnouncementToBeDisplayed} from '@modifi/plugin-banners'
import {selectLocale} from '@modifi/plugin-i18n'

import Layout from './Layout'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>) => ({
  locale: selectLocale(state),
  announcementToDisplay: selectAnnouncementToBeDisplayed(state),
})
const mapDispatchToProps = {
  fetchAnnouncements: aFetchAnnouncementData,
}

// @ts-expect-error to be fixed
export default connect(mapStateToProps, mapDispatchToProps)(Layout)
